(function () {
    const INPUT_SELECTORS = [
        'form[action*="/search"] input[name="q"]',
        '.header__search input[name="q"]'
    ];

    const MAX_RESULTS = 10;
    const MIN_CHARS = 1;
    const DEBOUNCE_MS = 120;

    const COLORS = [
        'black', 'white', 'blue', 'navy blue', 'light blue', 'dark blue', 'blue and white',
        'aqua', 'teal', 'turquoise',
        'green', 'sage green', 'forest green', 'olive green', 'mint green', 'moss green',
        'red', 'burgundy', 'maroon',
        'pink', 'hot pink', 'blush pink', 'rose pink',
        'purple', 'lavender', 'lilac', 'violet',
        'yellow', 'gold', 'mustard yellow',
        'orange', 'coral', 'peach',
        'brown', 'tan', 'beige', 'cream', 'ivory',
        'gray', 'grey', 'silver',
        'pastel', 'rainbow', 'multicolor', 'monochrome', 'neutral', 'black and gold'
    ];

    const AESTHETICS = [
        'gothic', 'boho', 'whimsy', 'whimsical', 'kawaii', 'cute', 'lo-fi', 'lo fi',
        'academia', 'dark academia', 'light academia', 'cottagecore', 'vaporwave',
        'cyberpunk', 'japandi', 'anime', 'goblincore', 'celestial', 'botanical',
        'cozy', 'luxury', 'witchy', 'goth', 'minimalist', 'maximalist',
        'art deco', 'art nouveau', 'chinoiserie', 'vintage', 'retro', 'y2k',
        'scandinavian', 'mid century', 'modern', 'moody', 'dark floral',
        'soft pastel', 'gaming aesthetic'
    ];

    const THEMES = [
        'floral', 'flower', 'botanical', 'cat', 'neko', 'dragon', 'koi fish',
        'cherry blossom', 'bamboo', 'cloud', 'moon', 'sun', 'stars', 'celestial',
        'topographic', 'line art', 'abstract', 'geometric', 'marble', 'gradient',
        'watercolor', 'mushroom', 'frog', 'forest', 'ocean', 'wave', 'space',
        'galaxy', 'skull', 'snake', 'butterfly', 'bird', 'tiger', 'mahjong',
        'desk setup', 'gaming setup', 'work from home'
    ];

    const MOODS = [
        'cute', 'cozy', 'calm', 'soft', 'dark', 'moody', 'bold', 'minimal',
        'elegant', 'luxury', 'playful', 'clean', 'premium', 'warm', 'neutral'
    ];

    const PRODUCT_TYPES = [
        'desk mat',
        'deskmat',
        'mousepad',
        'mouse pad',
        'ergonomic mousepad',
        'keyboard wrist rest',
        'wrist rest',
        'laptop sleeve',
        'laptop bag',
        'laptop case',
        'macbook sleeve',
        'desk chair cover',
        'office chair cover',
        'gaming chair cover',
        'mahjong mat',
        'mahjong table mat',
        'switch case',
        'switch 2 case',
        'switch accessories',
        'pegboard',
        'wall tapestry',
        'noren curtain',
        'card game mat',
        'card game playmat',
        'card game play mat',
        'playmat',
        'play mat',
        'TCG play mat',
        'TCG playmat',
        'tabletop playmat',
        'tabletop play mat',
        'board game mat',
        'board game play mat',
        'gaming playmat',
        'neoprene playmat'
    ];

    const CONSTRUCTABLE_PRODUCT_TYPES = [
        'desk mat',
        'mousepad',
        'mouse pad',
        'ergonomic mousepad',
        'keyboard wrist rest',
        'wrist rest',
        'laptop sleeve',
        'laptop bag',
        'laptop case',
        'macbook sleeve',
        'desk chair cover',
        'office chair cover',
        'gaming chair cover',
        'mahjong mat',
        'mahjong table mat',
        'switch case',
        'pegboard',
        'wall tapestry',
        'noren curtain',
        'card game mat',
        'playmat',
        'play mat',
        'TCG play mat',
        'tabletop playmat',
        'board game mat'
    ];

    const FEATURES = [
        'custom',
        'personalized',
        'make your own',
        'large',
        'extra large',
        'xl',
        'xxl',
        'extended',
        'oversized',
        'round',
        'square',
        'rectangle',
        'rectangular',
        'scalloped',
        'washable',
        'waterproof',
        'non slip',
        'non-slip',
        'stitched edge',
        'durable locked edge',
        'flat edge',
        'ergonomic',
        'wrist support',
        'padded',
        'neoprene',
        'with handle',
        'with shoulder strap',
        'shoulder strap',
        'led',
        'rgb',
        'gaming',
        'work from home',
        'desk setup',
        'office setup',
        'gift'
    ];

    const GIFT_AUDIENCES = [
        'gamer',
        'cat lover',
        'anime fan',
        'mahjong player',
        'office worker',
        'coworker',
        'student',
        'designer',
        'programmer',
        'developer',
        'remote worker',
        'work from home',
        'boyfriend',
        'girlfriend',
        'husband',
        'wife',
        'mom',
        'dad',
        'friend',
        'teacher'
    ];

    const LAPTOP_SIZE_SEARCHES = [
        'laptop sleeve 12 inch',
        'laptop sleeve 13 inch',
        'laptop sleeve 14 inch',
        'laptop sleeve 15 inch',
        'laptop sleeve 15.6 inch',
        'laptop sleeve 16 inch',
        'laptop sleeve 17 inch',
        'laptop bag 13 inch',
        'laptop bag 14 inch',
        'laptop bag 15 inch',
        'laptop bag 15.6 inch',
        'laptop bag 16 inch',
        'laptop bag 17 inch',
        'macbook sleeve 13 inch',
        'macbook sleeve 14 inch',
        'macbook sleeve 16 inch',
        'laptop sleeve with handle',
        'laptop bag with shoulder strap',
        'padded laptop sleeve',
        'neoprene laptop sleeve',
        'custom laptop sleeve',
        'laptop sleeve for women',
        'laptop bag for women'
    ];

    const DESK_MAT_SIZE_SEARCHES = [
        '800 x 300 mm desk mat',
        '900 x 400 mm desk mat',
        '100 x 50 cm desk mat',
        '120 x 60 cm desk mat',
        '80 x 30 cm desk mat',
        '90 x 40 cm desk mat',
        '24 x 12 inch desk mat',
        '24 x 14 inch desk mat',
        '31.5 x 11.8 inch desk mat',
        '35.6 x 15.8 inch desk mat',
        'large desk mat',
        'extra large desk mat',
        'xxl desk mat',
        'extended desk mat',
        'oversized desk mat',
        'gaming desk mat',
        'rgb desk mat',
        'led desk mat',
        'custom desk mat',
        'custom size desk mat',
        'custom shape desk mat',
        'cut to size desk mat',
        'personalized desk mat',
        'keyboard and mouse desk mat',
        'desk mat for keyboard and mouse',
        'desk mat with stitched edge',
        'desk mat without stitched edge',
        'desk mat with flat edge'
    ];

    const MOUSEPAD_SEARCHES = [
        'custom mousepad',
        'personalized mousepad',
        'large mousepad',
        'small mousepad',
        'round mousepad',
        'square mousepad',
        'gaming mousepad',
        'ergonomic mousepad',
        'washable mousepad',
        'waterproof mousepad',
        'non slip mousepad',
        'non-slip mousepad',
        'stitched edge mousepad',
        'mouse only mousepad',
        'mousepad for gaming',
        'mousepad for work'
    ];

    const MAHJONG_SEARCHES = [
        'mahjong mat',
        'custom mahjong mat',
        'large mahjong mat',
        'square mahjong mat',
        'mini mahjong mat',
        'small mahjong mat',
        'travel mahjong mat',
        'portable mahjong mat',
        'american mahjong mat',
        'riichi mahjong mat',
        'mahjong mat with rules',
        'mahjong mat with instructions',
        'mahjong table mat',
        'floral mahjong mat',
        'chinoiserie mahjong mat',
        'blue and white mahjong mat',
        'pink mahjong mat',
        'mahjong gift'
    ];

    const CARD_GAME_SEARCHES = [
        'card game mat',
        'card game playmat',
        'card game play mat',
        'TCG play mat',
        'TCG playmat',
        'tabletop playmat',
        'tabletop play mat',
        'board game mat',
        'board game play mat',
        'gaming playmat',
        'neoprene playmat',
        'custom playmat',
        'custom card game mat'
    ];

    const FUNCTION_SEARCHES = [
        'washable desk mat',
        'waterproof desk mat',
        'non slip desk mat',
        'non-slip desk mat',
        'stitched edge desk mat',
        'flat edge desk mat',
        'durable locked edge desk mat',
        'washable mousepad',
        'waterproof mousepad',
        'non slip mousepad',
        'non-slip mousepad',
        'stitched edge mousepad',
        'ergonomic mousepad',
        'wrist support mousepad',
        'keyboard wrist rest',
        'desk setup accessories',
        'work from home accessories',
        'gaming setup accessories'
    ];

    const EXTRA_AESTHETIC_SEARCHES = [
        'gothic desk mat',
        'boho desk mat',
        'whimsy desk mat',
        'whimsical desk mat',
        'kawaii desk mat',
        'cute desk mat',
        'lo-fi desk mat',
        'academia desk mat',
        'dark academia desk mat',
        'cottagecore desk mat',
        'vaporwave desk mat',
        'cyberpunk desk mat',
        'gothic mousepad',
        'boho mousepad',
        'kawaii mousepad',
        'cute mousepad',
        'lo-fi mousepad',
        'dark academia mousepad',
        'cottagecore mousepad',
        'vaporwave mousepad',
        'cyberpunk mousepad',
        'japandi desk mat',
        'japandi mousepad',
        'floral desk mat',
        'botanical desk mat',
        'minimalist desk mat',
        'black and gold desk mat',
        'blue and white desk mat',
        'sage green desk mat',
        'pink desk mat',
        'neutral desk mat'
    ];

    const HIGH_INTENT_SEARCHES = [
        'desk mat',
        'large desk mat',
        'xxl desk mat',
        'custom desk mat',
        'custom mousepad',
        'ergonomic mousepad',
        'keyboard wrist rest',
        'laptop sleeve',
        'laptop bag',
        'desk chair cover',
        'office chair cover',
        'mahjong mat',
        'custom mahjong mat',
        'rgb desk mat',
        'led desk mat',
        'gift for gamer',
        'gift for cat lover',
        'gift for coworker',
        'gift for remote worker',
        'gift for mahjong player'
    ];

    const STRUCTURED_TAGS = [
        'Color_Blue',
        'Color_Navy Blue',
        'Color_Black',
        'Color_White',
        'Color_Beige',
        'Color_Cream',
        'Color_Green',
        'Color_Sage Green',
        'Color_Pink',
        'Color_Purple',
        'Color_Gold',
        'Aesthetic_Gothic',
        'Aesthetic_Boho',
        'Aesthetic_Whimsical',
        'Aesthetic_Kawaii',
        'Aesthetic_Cute',
        'Aesthetic_Lo-Fi',
        'Aesthetic_Academia',
        'Aesthetic_Dark Academia',
        'Aesthetic_Cottagecore',
        'Aesthetic_Vaporwave',
        'Aesthetic_Cyberpunk',
        'Aesthetic_Japandi',
        'Aesthetic_Anime',
        'Aesthetic_Minimalist',
        'Theme_Floral',
        'Theme_Botanical',
        'Theme_Cat',
        'Theme_Celestial',
        'Theme_Gaming',
        'Theme_Mahjong',
        'Theme_Topographic',
        'Theme_Desk Setup',
        'Style_Modern',
        'Style_Vintage',
        'Style_Luxury',
        'Style_Cozy',
        'Mood_Cute',
        'Mood_Dark',
        'Mood_Calm',
        'Mood_Moody',
        'Mood_Pastel'
    ];

    const POPULAR_SEARCHES = [
        ...HIGH_INTENT_SEARCHES,
        ...LAPTOP_SIZE_SEARCHES,
        ...DESK_MAT_SIZE_SEARCHES,
        ...MOUSEPAD_SEARCHES,
        ...MAHJONG_SEARCHES,
        ...CARD_GAME_SEARCHES,
        ...FUNCTION_SEARCHES,
        ...EXTRA_AESTHETIC_SEARCHES
    ];

    const PRIORITY_TYPE_REGEX = /\b(desk\s*mats?|deskmats?|mouse\s*pads?|mousepads?|wrist\s*rests?|wristrests?|keyboard\s*wrist\s*rests?|ergonomic\s*mousepads?|laptop\s*sleeves?|laptop\s*bags?|desk\s*chair\s*covers?|office\s*chair\s*covers?|gaming\s*chair\s*covers?|mahjong\s*mats?|switch\s*cases?|pegboards?|wall\s*tapestr(?:y|ies)|noren\s*curtains?|card\s*game\s*mats?|play\s*mats?|playmats?|tcg\s*play\s*mats?|board\s*game\s*mats?)\b/i;
    const PRIORITY_GAMING_REGEX = /\b(gaming|rgb|led|lighted|illuminated|tcg)\b/i;
    const PRIORITY_SHAPE_REGEX = /\b(round|square|rectangle|rectangular|scalloped|extended|xxl|xl|xxxl|oversized|large|extra\s*large|800\s*x\s*300|900\s*x\s*400|100\s*x\s*50|120\s*x\s*60|24\s*x\s*12|24\s*x\s*14|31\.5\s*x\s*11\.8|35\.6\s*x\s*15\.8)\b/i;
    const PRIORITY_CUSTOM_REGEX = /\b(custom|personalized|personalised|customized|customised|make\s*(your|ya|ur)?\s*own|cut\s*to\s*size)\b/i;
    const PRIORITY_GIFT_REGEX = /\b(gift|gift\s*for|present|birthday|christmas|holiday)\b/i;
    const PRIORITY_FUNCTION_REGEX = /\b(washable|waterproof|non\s*-?\s*slip|stitched\s*edge|durable\s*locked\s*edge|flat\s*edge|ergonomic|wrist\s*support|padded|neoprene|with\s*handle|shoulder\s*strap)\b/i;
    const PRIORITY_BUYER_REGEX = /\b(setup|office|work\s*from\s*home|remote\s*worker|gaming\s*setup|desk\s*setup|for\s*women)\b/i;

    const COLOR_REGEX = new RegExp('\\b(' + COLORS.map(function (word) {
        return word.replace(/\s+/g, '\\s+');
    }).join('|') + ')\\b', 'i');

    const debounce = function (fn, delay) {
        let timer;

        return function () {
            const args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(null, args);
            }, delay);
        };
    };

    const normalize = function (value) {
        return String(value || '')
            .toLowerCase()
            .replace(/[_-]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const escapeHtml = function (value) {
        return String(value || '').replace(/[&<>"']/g, function (char) {
            return {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            }[char];
        });
    };

    const unique = function (arr) {
        const seen = new Set();

        return arr.filter(function (item) {
            const key = normalize(item);

            if (!key || seen.has(key)) return false;

            seen.add(key);
            return true;
        });
    };

    const cleanStructuredTag = function (tag) {
        return normalize(
            String(tag || '').replace(/^(Color|Theme|Style|Aesthetic|Mood|Subject|Product)_/i, '')
        );
    };

    const words = function (value) {
        return normalize(value).split(' ').filter(Boolean);
    };

    function priorityBoost(text) {
        let bonus = 0;

        if (PRIORITY_TYPE_REGEX.test(text)) bonus += 80;
        if (PRIORITY_CUSTOM_REGEX.test(text)) bonus += 55;
        if (PRIORITY_GIFT_REGEX.test(text)) bonus += 45;
        if (PRIORITY_GAMING_REGEX.test(text)) bonus += 40;
        if (PRIORITY_FUNCTION_REGEX.test(text)) bonus += 38;
        if (PRIORITY_SHAPE_REGEX.test(text)) bonus += 35;
        if (COLOR_REGEX.test(text)) bonus += 30;
        if (PRIORITY_BUYER_REGEX.test(text)) bonus += 20;

        return bonus;
    }

    function matchesTypedPhrase(phrase, typed) {
        const phraseWords = words(phrase);
        const typedWords = words(typed);

        if (!typedWords.length) return false;

        let phraseIndex = 0;

        for (const typedWord of typedWords) {
            let found = false;

            while (phraseIndex < phraseWords.length) {
                const phraseWord = phraseWords[phraseIndex];

                if (phraseWord.startsWith(typedWord)) {
                    found = true;
                    phraseIndex++;
                    break;
                }

                phraseIndex++;
            }

            if (!found) return false;
        }

        return true;
    }

    function highlight(text, query) {
        const rawText = String(text || '');
        const q = normalize(query);

        if (!q) return escapeHtml(rawText);

        const textParts = rawText.split(/(\s+)/);

        return textParts.map(function (part) {
            const cleanPart = normalize(part);

            if (!cleanPart) return escapeHtml(part);

            const matchingQueryWord = words(q).find(function (queryWord) {
                return cleanPart.startsWith(queryWord);
            });

            if (matchingQueryWord) {
                return '<strong>' + escapeHtml(part) + '</strong>';
            }

            return escapeHtml(part);
        }).join('');
    }

    const STRUCTURED_TERMS = STRUCTURED_TAGS.map(cleanStructuredTag);

    const MODIFIERS = unique([
        ...COLORS,
        ...AESTHETICS,
        ...THEMES,
        ...MOODS,
        ...FEATURES,
        ...STRUCTURED_TERMS
    ]);

    function buildLocalPhraseBank() {
        const phrases = [];

        phrases.push(...POPULAR_SEARCHES);
        phrases.push(...COLORS);
        phrases.push(...AESTHETICS);
        phrases.push(...THEMES);
        phrases.push(...MOODS);
        phrases.push(...FEATURES);
        phrases.push(...PRODUCT_TYPES);
        phrases.push(...STRUCTURED_TERMS);

        phrases.push(...LAPTOP_SIZE_SEARCHES);
        phrases.push(...DESK_MAT_SIZE_SEARCHES);
        phrases.push(...MOUSEPAD_SEARCHES);
        phrases.push(...MAHJONG_SEARCHES);
        phrases.push(...CARD_GAME_SEARCHES);
        phrases.push(...FUNCTION_SEARCHES);
        phrases.push(...EXTRA_AESTHETIC_SEARCHES);
        phrases.push(...HIGH_INTENT_SEARCHES);

        MODIFIERS.forEach(function (modifier) {
            CONSTRUCTABLE_PRODUCT_TYPES.forEach(function (product) {
                const modifierClean = normalize(modifier);
                const productClean = normalize(product);

                if (!modifierClean || !productClean) return;
                if (productClean.startsWith(modifierClean + ' ')) return;

                phrases.push(modifierClean + ' ' + productClean);
            });
        });

        GIFT_AUDIENCES.forEach(function (audience) {
            phrases.push('gift for ' + audience);
        });

        return unique(phrases);
    }

    const LOCAL_PHRASES = buildLocalPhraseBank();

    function scoreSuggestion(text, query, source) {
        const t = normalize(text);
        const q = normalize(query);
        const qWords = words(query);
        let score = 0;

        if (t === q) score += 1000;
        if (t.startsWith(q)) score += 500;
        if (matchesTypedPhrase(t, q)) score += 300;

        qWords.forEach(function (queryWord) {
            if (words(t).some(function (termWord) {
                return termWord.startsWith(queryWord);
            })) {
                score += 80;
            }

            if (t.includes(queryWord)) {
                score += 30;
            }
        });

        score += priorityBoost(text);

        if (PRODUCT_TYPES.some(function (product) {
            return t === normalize(product);
        })) {
            score += 120;
        }

        if (POPULAR_SEARCHES.some(function (popular) {
            return t === normalize(popular);
        })) {
            score += 100;
        }

        if (source === 'local') score += 40;
        if (source === 'shopify') score += 25;

        if (t.length <= 18) score += 20;
        if (t.length > 60) score -= 60;

        return score;
    }

    function getLocalSuggestions(query) {
        return LOCAL_PHRASES
            .filter(function (phrase) {
                return matchesTypedPhrase(phrase, query);
            })
            .map(function (phrase) {
                return {
                    text: phrase,
                    source: 'local',
                    score: scoreSuggestion(phrase, query, 'local')
                };
            });
    }

    const shopifyQueryCache = new Map();

    async function fetchShopifyQuerySuggestions(query) {
        const q = normalize(query);

        if (shopifyQueryCache.has(q)) {
            return shopifyQueryCache.get(q);
        }

        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';

        const url =
            root + 'search/suggest.json' +
            '?q=' + encodeURIComponent(query) +
            '&resources[type]=query' +
            '&resources[limit]=6' +
            '&resources[limit_scope]=all';

        try {
            const response = await fetch(url, {
                headers: {
                    Accept: 'application/json'
                }
            });

            if (!response.ok) {
                shopifyQueryCache.set(q, []);
                return [];
            }

            const data = await response.json();
            const queries = data && data.resources && data.resources.results && data.resources.results.queries
                ? data.resources.results.queries
                : [];

            const results = queries
                .map(function (item) {
                    return item && item.text ? item.text : '';
                })
                .filter(Boolean)
                .map(function (text) {
                    return {
                        text: text,
                        source: 'shopify',
                        score: scoreSuggestion(text, query, 'shopify')
                    };
                });

            shopifyQueryCache.set(q, results);
            return results;
        } catch (error) {
            shopifyQueryCache.set(q, []);
            return [];
        }
    }

    function ensureSuggestionBox(input) {
        const wrapper = input.closest('.input-group') || input.parentElement;

        if (!wrapper) return null;

        if (getComputedStyle(wrapper).position === 'static') {
            wrapper.style.position = 'relative';
        }

        let box = wrapper.querySelector('.suggestion-box');

        if (!box) {
            box = document.createElement('div');
            box.className = 'suggestion-box';
            wrapper.appendChild(box);
        }

        box.setAttribute('role', 'listbox');

        return box;
    }

    function mergeAndRankSuggestions(query, localItems, shopifyItems) {
        const merged = [...localItems, ...shopifyItems];
        const byText = new Map();

        merged.forEach(function (item) {
            const key = normalize(item.text);

            if (!key) return;

            const existing = byText.get(key);

            if (!existing || item.score > existing.score) {
                byText.set(key, item);
            }
        });

        return Array.from(byText.values())
            .sort(function (a, b) {
                return b.score - a.score;
            })
            .slice(0, MAX_RESULTS);
    }

    function renderSuggestions(input, box, items, query) {
        box.innerHTML = '';

        if (!items.length) {
            box.style.display = 'none';
            return;
        }

        items.forEach(function (item, index) {
            const option = document.createElement('button');

            option.type = 'button';
            option.className = 'suggestion-item';
            option.setAttribute('role', 'option');
            option.dataset.index = String(index);
            option.dataset.value = item.text;

            option.innerHTML =
                '<span>' + highlight(item.text, query) + '</span>' +
                '<span class="suggestion-type">Search</span>';

            option.addEventListener('mouseenter', function () {
                setActiveOption(box, index);
            });

            option.addEventListener('click', function () {
                submitSuggestion(input, box, item.text);
            });

            box.appendChild(option);
        });

        setActiveOption(box, -1);
        box.style.display = 'block';
    }

    function setActiveOption(box, activeIndex) {
        const options = Array.from(box.querySelectorAll('.suggestion-item'));

        options.forEach(function (option, index) {
            if (index === activeIndex) {
                option.dataset.active = 'true';
            } else {
                option.dataset.active = 'false';
            }
        });
    }

    function getActiveOption(box) {
        return box.querySelector('.suggestion-item[data-active="true"]');
    }

    function submitSuggestion(input, box, text) {
        input.value = text;
        box.innerHTML = '';
        box.style.display = 'none';

        const form = input.closest('form');

        if (form) {
            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit();
            } else {
                form.submit();
            }
        }
    }

    function initInput(input) {
        if (!input || input.dataset.dnNaturalSearch === 'true') return;

        input.dataset.dnNaturalSearch = 'true';
        input.setAttribute('autocomplete', 'off');

        const box = ensureSuggestionBox(input);

        if (!box) return;

        const runSearch = debounce(async function () {
            const query = input.value.trim();

            if (query.length < MIN_CHARS) {
                box.innerHTML = '';
                box.style.display = 'none';
                return;
            }

            const localSuggestions = getLocalSuggestions(query);
            const shopifySuggestions = await fetchShopifyQuerySuggestions(query);
            const suggestions = mergeAndRankSuggestions(query, localSuggestions, shopifySuggestions);

            renderSuggestions(input, box, suggestions, query);
        }, DEBOUNCE_MS);

        input.addEventListener('input', runSearch);

        input.addEventListener('keydown', function (event) {
            const options = Array.from(box.querySelectorAll('.suggestion-item'));

            if (event.key === 'Escape') {
                box.innerHTML = '';
                box.style.display = 'none';
                return;
            }

            if (!options.length) return;

            const currentIndex = options.findIndex(function (option) {
                return option.dataset.active === 'true';
            });

            if (event.key === 'ArrowDown') {
                event.preventDefault();
                const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
                setActiveOption(box, nextIndex);
            }

            if (event.key === 'ArrowUp') {
                event.preventDefault();
                const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
                setActiveOption(box, prevIndex);
            }

            if (event.key === 'Enter') {
                const activeOption = getActiveOption(box);

                if (activeOption) {
                    event.preventDefault();
                    submitSuggestion(input, box, activeOption.dataset.value);
                }
            }
        });

        document.addEventListener('click', function (event) {
            if (!box.contains(event.target) && event.target !== input) {
                box.innerHTML = '';
                box.style.display = 'none';
            }
        });
    }

    function init() {
        INPUT_SELECTORS.forEach(function (selector) {
            document.querySelectorAll(selector).forEach(initInput);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
